import "./styles/App.css";
import { routeTree } from "./routeTree.gen";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AntdThemeConfigProvider } from "./styles/AntdThemeProvider.tsx";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { RouteNotFound } from "./components/RouteNotFound.tsx";
import type { Account } from "./api/AccountSchema.ts";

function App() {
  // Definiere den Kontext-Typ
  type RouterContextType = {
    account: Account | undefined;
    // authService: AuthService; //Later for Authentication
  };

  const router = createRouter({
    routeTree,
    context: { account: undefined } as RouterContextType,
    defaultNotFoundComponent: RouteNotFound,
    defaultViewTransition: true,
  });

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 2,
        retryDelay: 250,
        staleTime: 1000 * 10, // 10 sec
        gcTime: 1000 * 10, // 10 sec
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      {/*i18*/}
      <AntdThemeConfigProvider>
        <RouterProvider router={router} />
      </AntdThemeConfigProvider>
    </QueryClientProvider>
  );
}

export default App;
